import styled from '@emotion/styled'
import { Typography } from '@yanolja-rnd/ya-com-core'
import { Icon_arrowmore_fill } from '@yanolja-rnd/ya-com-system-icon'
import { FC, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

const ShowMore = styled.button`
  display: flex;
  align-items: center;
  height: 4.8rem;
  justify-content: center;
  width: 100%;
  ${Typography('body1').regular};
`

const ArrowIcon = styled(Icon_arrowmore_fill)<{ open: boolean }>`
  margin-left: 0.6rem;
  ${({ open }) => open && `transform: rotate(180deg)`};
`

interface OrderListShowMoreProps {
  isShowMore: boolean
  remainingCount: number
  className?: string
  onClick: () => void
  onImpressed?: () => void
}

const OrderListShowMore: FC<OrderListShowMoreProps> = ({
  isShowMore,
  remainingCount,
  className,
  onClick,
  onImpressed,
}) => {
  const { ref, inView } = useInView({ triggerOnce: true })

  useEffect(() => {
    if (inView) {
      onImpressed?.()
    }
  }, [inView])

  return (
    <ShowMore ref={ref} onClick={onClick} className={className}>
      {isShowMore ? '접기' : `${remainingCount}개 상품 더보기`}
      <ArrowIcon open={isShowMore} size={1.2} unit="rem" />
    </ShowMore>
  )
}

export default OrderListShowMore
